import RecommendedProductList from './RecommendedProductList'

export default RecommendedProductList
